import { useCallback, useEffect, useMemo, useState } from 'react';
import { DataProviderInstance } from '../../../../../../api/DataProvider';
import { normalizePackages, summarize } from './walletFormat';

/**
 * Carteira de um paciente: pacotes normalizados, resumo e últimos movimentos.
 * Quem orquestra a aba usa o resumo no topo e passa o resto para a seção de
 * pacotes; `refresh()` recarrega depois de uma venda.
 */
export default function usePatientWallet(patientId) {
  const { GetPatientWallet, GetWalletTransactions } = DataProviderInstance();

  const [wallet, setWallet] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(() => {
    GetPatientWallet(patientId, (response) => {
      if (!response.success) {
        setLoading(false);
        return;
      }
      setWallet(response.data);
      // Sem período: o backend devolve os últimos movimentos.
      GetWalletTransactions(response.data.wallet_id, null, null, (transResponse) => {
        if (transResponse.success) {
          setTransactions(transResponse.data.transactions || []);
        }
        setLoading(false);
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const packages = useMemo(() => normalizePackages(wallet), [wallet]);
  const summary = useMemo(() => summarize(packages), [packages]);

  return {
    wallet,
    transactions,
    loading,
    refresh,
    packages,
    summary,
    monetaryBalance: Number(wallet?.monetary_balance) || 0,
  };
}
